import React, { useState, useEffect } from 'react';
import { Card } from 'primereact/card';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { useMediaQuery } from '@mui/material';
import { getMerchandiseBySupplier, deleteMerchandise } from '../../../services/api';
import DetalhesModal from '../../modals/detalhesmerchandise'; // Modal de detalhes
import ConfirmModal from '../../modals/confirmx'; // Modal de confirmação

const VerArtigosPorFornecedor = () => {
    const [articles, setArticles] = useState([]);
    const [loading, setLoading] = useState(false);
    const [globalFilter, setGlobalFilter] = useState('');
    const [selectedProduct, setSelectedProduct] = useState(null);
    const [showDetalhesModal, setShowDetalhesModal] = useState(false);
    const [showConfirmDelete, setShowConfirmDelete] = useState(false);
    const [productToDelete, setProductToDelete] = useState(null);
    const isMobile = useMediaQuery('(max-width:800px)');

    useEffect(() => {
        const fetchArticles = async () => {
            setLoading(true);
            try {
                const response = await getMerchandiseBySupplier();
                // Filtra para somente artigos que possuem fornecedores
                const filteredArticles = response.data.filter(article => 
                    article.suppliers && article.suppliers.length > 0
                );
                setArticles(filteredArticles);
            } catch (error) {
                console.error("Erro ao buscar artigos por fornecedor", error);
            }
            setLoading(false);
        };

        fetchArticles();
    }, []);

    // Template para exibir o estoque atual
    const stockBodyTemplate = (rowData) => rowData.current_quantity || 0;

    // Template para exibir os fornecedores associados
    const supplierBodyTemplate = (rowData) => {
        if (rowData.suppliers && rowData.suppliers.length > 0) {
            return rowData.suppliers.map(supplier => supplier.name).join(', ');
        }
        return "Sem fornecedor";
    };

    // Ações: visualizar detalhes e excluir
    const actionBodyTemplate = (rowData) => {
        return (
            <div>
                <Button 
                    icon="pi pi-info-circle" 
                    className="p-button-rounded p-button-text" 
                    onClick={() => handleViewDetails(rowData)}
                />
                <Button 
                    icon="pi pi-trash" 
                    className="p-button-rounded p-button-text p-button-danger" 
                    onClick={() => handleDeleteClick(rowData)}
                />
            </div>
        );
    };

    // Abre a modal de detalhes
    const handleViewDetails = (rowData) => {
        setSelectedProduct(rowData);
        setShowDetalhesModal(true);
    };

    // Ao clicar no botão de excluir, abre a modal de confirmação
    const handleDeleteClick = (rowData) => {
        setProductToDelete(rowData);
        setShowConfirmDelete(true);
    };

    // Confirma a exclusão chamando a API
    const confirmDelete = async () => {
        try {
            await deleteMerchandise(productToDelete.id);
            setArticles(prev => prev.filter(product => product.id !== productToDelete.id));
        } catch (error) {
            console.error("Erro ao eliminar produto", error);
        } finally {
            setShowConfirmDelete(false);
            setProductToDelete(null);
        }
    };

    const header = (
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <span className="p-input-icon-right">
                <InputText 
                    type="search" 
                    onInput={(e) => setGlobalFilter(e.target.value)} 
                    placeholder="Pesquisar por fornecedor" 
                    size="50" 
                />
                <i className="pi pi-search" style={{ right: '10px' }} />
            </span>
        </div>
    );

    return (
        <Card title="Artigos por Fornecedor">
            <DataTable 
                value={articles} 
                paginator 
                rows={isMobile ? 5 : 10} 
                header={header} 
                globalFilter={globalFilter} 
                loading={loading}
                responsiveLayout="scroll"
                emptyMessage="Nenhum artigo encontrado."
            >
                <Column field="name" header="Nome" sortable />
                <Column field="reference" header="Referência" sortable />
                <Column body={stockBodyTemplate} header="Stock" sortable />
                <Column body={supplierBodyTemplate} header="Fornecedor" sortable />
                <Column body={actionBodyTemplate} header="Ações" exportable={false} style={{ minWidth: '8rem' }} />
            </DataTable>

            {/* Modal de detalhes */}
            <DetalhesModal 
                visible={showDetalhesModal} 
                onHide={() => setShowDetalhesModal(false)} 
                merchandise={selectedProduct}
            />

            {/* Modal de confirmação para exclusão */}
            <ConfirmModal 
                visible={showConfirmDelete}
                message={`Tem certeza que deseja eliminar o produto ${productToDelete ? productToDelete.name : ''}?`}
                onConfirm={confirmDelete}
                onCancel={() => {
                    setShowConfirmDelete(false);
                    setProductToDelete(null);
                }}
            />
        </Card>
    );
};

export default VerArtigosPorFornecedor;
